import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { measureWebVitals } from './utils/performance'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Measure Web Vitals in production
if (import.meta.env.PROD) {
  measureWebVitals((metric) => {
    // Log to console in development, can send to analytics in production
    if (import.meta.env.DEV) {
      console.log('[Web Vitals]', metric)
    }
    // TODO: Send to analytics service in production
  })
}
